module.exports = __webpack_public_path__ + "static/media/step4.aeb3da35.gif";